@let dialect = dialect$ | async;

<div>
  @if (dialect?.data || dialect?.failure || dialect?.loading){
  <hr />
  <h2 class="mb-12">Dialeto</h2>

  @if (dialect?.data) {
  <pds-table>
    <table>
      <thead>
        <tr>
          <th>Dialeto</th>
          <th>Grupo</th>
          <th>Especições</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ dialect?.data?.query }}</td>
          <td>
            @for (item of dialect?.data?.filter?.productGroups; track $index) {
            <span pdsChip>{{ item.name }}</span>
            }
          </td>
          <td>
            @if (!dialect?.data?.filter?.specifications || !dialect?.data?.filter?.specifications?.length) {
            <span>-</span>
            } @else {
            <table>
              @for (item of dialect?.data?.filter?.specifications; track $index) {
              <tr>
                <th>{{ item.name }}</th>
                <td>
                  <div style="display: flex; gap: 8px; flex-direction: column">
                    @for (value of item.values; track $index) {
                    <span pdsChip>{{ value }}</span>
                    }
                  </div>
                </td>
              </tr>
              }
            </table>
            }
          </td>
          <td pdsColActions>
            <button pdsButton="icon" title="Ver Detalhes" (click)="onClickDialectDetails(dialect?.data)">
              <span class="icon">visibility</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </pds-table>
  } @else if (dialect?.loading) {
  <h4>Carregando dialeto...</h4>
  } @else if (dialect?.failure) {
  <h4>Falha ao carregar dialeto</h4>
  } }
</div>
